module.exports = "<div class=\"img lazy-loaded-img loading\" width=\"100%\" #lazyImageWrapper>\r\n    <img [src]=\"ImageSource\" (load)=\"onloadImage($event)\" (error)=\"loadFallbackImage($event)\" #lazyImage/>\r\n    <div class=\"loader-overlay lds-facebook\"><div></div><div></div><div></div></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/lazy-loaded-image/lazy-loaded-image.component.html
// module id = ./src/app/shared/components/lazy-loaded-image/lazy-loaded-image.component.html
// module chunks = main